import { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { CTAButton } from '../components/CTAButton';
import { ProgressDots } from '../components/ProgressDots';
import { useFlow } from '../state/flowStore';

export function AgeScreen() {
  const nav = useNavigate();
  const { realAge, setAge } = useFlow();
  const [text, setText] = useState(realAge > 0 ? String(realAge) : '');
  const input = useRef<HTMLInputElement>(null);

  useEffect(() => {
    input.current?.focus();
  }, []);

  const age = Number(text);
  const valid = Number.isFinite(age) && age >= 13 && age <= 99;

  return (
    <div className="lume-bg min-h-svh flex flex-col">
      <ProgressDots current={0} total={2} />
      <div className="px-7 pt-10 flex-1 flex flex-col">
        <h1 className="text-headline text-text">How old are you?</h1>
        <p className="text-body text-text-secondary mt-2">
          We use this to calibrate your skin age reading.
        </p>

        <input
          ref={input}
          inputMode="numeric"
          pattern="[0-9]*"
          maxLength={2}
          placeholder="26"
          value={text}
          onChange={e => setText(e.target.value.replace(/\D/g, '').slice(0, 2))}
          className="mt-6 w-full bg-transparent text-text font-extrabold outline-none caret-accent"
          style={{ fontSize: 'clamp(64px, 18vw, 88px)', lineHeight: 1 }}
        />

        {text.length === 2 && !valid && (
          <p className="text-caption text-danger mt-2">Must be 13 or older to use Lumé.</p>
        )}

        <div className="flex-1" />

        <CTAButton
          label="Continue"
          disabled={!valid}
          onClick={() => {
            setAge(age);
            nav('/focus');
          }}
        />
        <div className="h-12" />
      </div>
    </div>
  );
}
